export default "__VITE_ASSET__NP68_LF$__"